module.exports = __webpack_public_path__ + "img/kick-scooter.ca9b73fb.png";